import { useState } from 'react';

export default function ContactSection() {
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      form.reset();
      setSubmitStatus('success');
      setTimeout(() => setSubmitStatus('idle'), 3000);
      return;
    }

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          body.append(key, value as string);
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9kv4tuc26n1c7c5qni0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        form.reset();
      } else {
        setSubmitStatus('error');
        setErrorMsg(parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试');
      }
    } catch {
      setSubmitStatus('error');
      setErrorMsg('网络错误，请检查网络连接后重试');
    }

    setTimeout(() => {
      setSubmitStatus('idle');
      setErrorMsg('');
    }, 4000);
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
            <p className="mt-2 text-sm text-foreground-500">有问题或建议？欢迎联系我们反馈</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-lg text-primary-600"></i>
              </div>
              <div className="text-sm font-semibold text-foreground-900">邮件联系</div>
              <div className="text-xs text-foreground-500 mt-1">support@91free.com</div>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-chat-3-line text-lg text-accent-700"></i>
              </div>
              <div className="text-sm font-semibold text-foreground-900">在线反馈</div>
              <div className="text-xs text-foreground-500 mt-1">填写下方表单提交</div>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-10 h-10 mx-auto rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-file-add-line text-lg text-secondary-700"></i>
              </div>
              <div className="text-sm font-semibold text-foreground-900">内容投稿</div>
              <div className="text-xs text-foreground-500 mt-1">欢迎优质内容创作者</div>
            </div>
          </div>

          <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
            {submitStatus === 'success' && (
              <div className="mb-4 p-3 bg-accent-50 border border-accent-200 rounded-lg text-sm text-accent-800 text-center">
                消息已发送成功，我们会尽快回复你！
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="mb-4 p-3 bg-primary-50 border border-primary-200 rounded-lg text-sm text-primary-700 text-center">
                {errorMsg}
              </div>
            )}

            <form
              id="contact-form"
              data-readdy-form="true"
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="你的称呼"
                  required
                  className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="邮箱地址"
                  required
                  className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                />
              </div>
              <input
                type="text"
                name="subject"
                placeholder="主题"
                required
                className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
              <textarea
                name="message"
                placeholder="请描述你的问题或建议..."
                rows={4}
                maxLength={500}
                required
                className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
              ></textarea>

              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />

              <button
                type="submit"
                className="w-full py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                发送消息
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}